/** Numbers for people: a French club reads "1 234,5". Never used to parse input (see parseDecimal). */
export const fmtNum = (n: number, lang: string, max = 2): string =>
  new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'fr-FR', { maximumFractionDigits: max }).format(n)

/** What somebody types into a meter field: "1 234,5", "1234.5", "1,234.5" (thousands comma) -> 1234.5; anything else -> null. */
export function parseDecimal(raw: string): number | null {
  const s = raw.replace(/[\s  ]/g, '')
  if (!s) return null
  let t = s
  if (/^\d{1,3}(,\d{3})+(\.\d+)?$/.test(s)) t = s.replace(/,/g, '')
  else if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) t = s.replace(/\./g, '').replace(',', '.')
  else t = s.replace(',', '.')
  if (!/^\d+(\.\d+)?$/.test(t)) return null
  const n = Number(t)
  return Number.isFinite(n) ? Math.round(n * 100) / 100 : null
}
